import { MachineApprovalStatus } from '../../constants/machine/machine.constant';
import { IMachine } from '../../interfaces/Machine.interfaces';

export interface IOpenMarketProductForGetTitle {
  brandName: string;
  machine: IMachine;
  showPsOnPendingApproval?: boolean;
}

export const getOpenMarketProductTitle = ({
  brandName,
  machine,
  showPsOnPendingApproval,
}: IOpenMarketProductForGetTitle) => {
  if (!machine) {
    return '';
  }

  const { APPROVAL, PSWAITING } = MachineApprovalStatus;
  const isApproved = machine.approvalStatus === APPROVAL;
  const isPendingApproval = showPsOnPendingApproval && machine.approvalStatus === PSWAITING;
  const isMachineTypeCombine = machine.machineType === 'combine';

  const baseTitle = `${brandName} ${machine.model} ${isMachineTypeCombine ? '콤바인' : '트랙터'}`;

  if (isApproved || isPendingApproval) {
    const specification = isMachineTypeCombine ? machine.rowConfig : `${machine.engineOutputInPs}마력`;
    return `${baseTitle} (${specification})`;
  }

  return baseTitle;
};
